module.exports = urlProcess;

function urlProcess(string) {
  return string.replace(/[\W_]/gi, '-');
}
